function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
// eslint-disable-next-line no-restricted-imports
import { jsx } from 'panel';
import type { VNode } from 'snabbdom';
import type { JsxVNodeChildren } from 'snabbdom-jsx-lite';
import { HORIZONTAL_CONTENT_PADDING_STYLE } from 'common/report/layout/banner-layout/index';
import { ReportMessageBannerEl } from 'common/widgets/report-message-banner';
import { ReportBannersEl } from 'common/widgets/report-banners';
import { isTestEnv } from 'common/report/util/env';
import { ReportLayoutManager } from 'common/report/contexts/report-layout';

/**
 * @deprecated
 * This is a legacy version of BannerLayout that's used by reports that haven't been converted to React.
 * New reports should use the React version of BannerLayout.
 */
export function ContentFrame(_ref: {
  sel?: string;
  contentFrameClass?: Record<string, boolean>;
  minContentWidth?: number;
  maxContentWidth?: number;
  isCoreReport?: boolean;
  reportLayoutManager?: ReportLayoutManager;
}, block: JsxVNodeChildren): VNode {
  let {
    sel,
    contentFrameClass,
    minContentWidth,
    maxContentWidth,
    isCoreReport,
    reportLayoutManager
  }: {
    sel?: string;
    contentFrameClass?: Record<string, boolean>;
    minContentWidth?: number;
    maxContentWidth?: number;
    isCoreReport?: boolean;
    reportLayoutManager?: ReportLayoutManager;
  } = _ref;
  return <div sel={sel} class={_objectSpread(_objectSpread({}, contentFrameClass), {}, {
    'content-frame': true,
    'inherit-size': true
  })} data-sentry-component="ContentFrame" data-sentry-source-file="content-frame.tsx">
      <div sel='.width-frame' class={{
      'inherit-size': true
    }} style={{
      margin: isCoreReport ? null : "0 auto",
      'max-width': maxContentWidth ? "".concat(maxContentWidth, "px") : undefined,
      'min-width': minContentWidth ? "".concat(minContentWidth, "px") : undefined
    }}>
        <div sel='.padding-frame' class={{
        'inherit-size': true,
        'scroll-container': true
      }} style={{
        'box-sizing': "border-box",
        'overflow-y': "auto",
        padding: isCoreReport ? "32px 0 0 0" : "0 ".concat(HORIZONTAL_CONTENT_PADDING_STYLE, " 6vh ").concat(HORIZONTAL_CONTENT_PADDING_STYLE)
      }} hook={{
        insert: (vnode: VNode) => {
          reportLayoutManager === null || reportLayoutManager === void 0 || reportLayoutManager.updateScrollContainer(vnode.elm as HTMLElement);
        }
      }}>
          {!isTestEnv() && !isCoreReport && <div sel='.banner-container' style={{
          'margin-top': "20px"
        }}>
              <ReportMessageBannerEl />
              <ReportBannersEl />
            </div>}
          {block}
        </div>
      </div>
    </div>;
}